<form>
  <div ngbDropdown class="d-flex d-xxxl-none mr-1">
    <sb-button classes="btn-hover-primary d-flex align-items-center m-0" ngbDropdownToggle>
      <sb-icon icon="circleSelected" class="icon-in-btn"></sb-icon>&nbsp;
      {{ titles ? (titles[selectedVal] ? titles[selectedVal] : selectedVal) : selectedVal}}
      <sb-icon class="ml-2" style="" icon="chevronDown"></sb-icon>
    </sb-button>
    <div ngbDropdownMenu>
      <ul class="dropdown">
        <li class="item" *ngFor="let sel of selections">
          <a class="item-link" (click)="change(sel, {target:{checked: true}})">
            <div class="radio-inline">
              <label class="radio-inline__radioButton">
                <input type="radio" [disabled]="true" [checked]="sel === selectedVal">
                {{ titles ? (titles[sel] ? titles[sel] : sel) : sel}}
                <span></span>
              </label>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="radio-inline mr-1 d-xxxl-flex d-none" style="flex: 1;">
    <label *ngFor="let sel of selections" class="radio-inline__radioButton" [ngbTooltip]="selectionsHovers[sel]">
      <input type="radio" [checked]="sel === selectedVal" (change)="change(sel, $event)">
      {{ titles ? (titles[sel] ? titles[sel] : sel) : sel}}
      <span></span>
    </label>
  </div>
</form>
